// =====================================================================
// Hilfsfunktionen rund um Materialanforderungen.
//
// Der Python-Dienst (Test.py) schreibt in MatArtikel.Fall den Wert des
// Markierungsartikels. Für den SOFORT-Fall ist das 'SOFORT'. Da in der
// Stammdaten-Tabelle MatFaelle die Schreibweise abweichen kann ('Sofort'),
// wird hier bewusst case-insensitiv verglichen.
// =====================================================================

/** true, wenn die Artikelposition den Fall SOFORT trägt */
export const istSofortArtikel = (art) =>
  String(art?.fall ?? '').trim().toUpperCase() === 'SOFORT';

/** true, wenn die Anforderung mindestens einen SOFORT-Artikel enthält */
export const hatSofort = (anforderung) =>
  Array.isArray(anforderung?.artikel) && anforderung.artikel.some(istSofortArtikel);
